import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';

@Component({
    selector: 'kx-payment-status',
    templateUrl: './payment-status.component.html',
    styleUrls: ['./payment-status.component.scss'],
    standalone: false
})
export class PaymentStatusComponent extends UiEngineComponent implements OnInit {
  data: any
  status: any;

  constructor(
    public injector: Injector,
    public smartModelService: BsModalRef,
    public baseService: BaseService,
    public authenticationService: AuthenticationService,
    public modal: BsModalService,
    public appService: AppService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    super(injector, router, route, modal)
  }

  ngOnInit() {
    this.data = this['data'];
    this.status = JSON.parse(this.data.status);
    console.log()
    // this.locationStrategy.onPopState(() => {
    //   history.forward();
    // })
  }

  Orders() {
    this.hide();
    if (this.authenticationService.getUserType() == "patient") {
      //For pharmacy draft payment
      if (this.data && this.data.ordersReturnUrl) {
        this.router.navigateByUrl(this.data.ordersReturnUrl);
        return;
      }
      if (this.appService.isCSPAccount()) {
        this.router.navigate(['order/citizen_orders_format/orderList'])
      }
      else if (this.baseService && this.baseService.route && this.baseService.route.snapshot && this.baseService.route.snapshot['_routerState'] && this.baseService.route.snapshot['_routerState'].url && this.baseService.route.snapshot['_routerState'].url.includes('ip_advance_payment')) {
        // set by OnlinePayment decorator; reload via /search since the popup is already on this route
        let returnTab = null;
        try {
          returnTab = sessionStorage.getItem('ipAdvanceReturnTab');
          sessionStorage.removeItem('ipAdvanceReturnTab');
        } catch (e) {
          returnTab = null;
        }
        if (returnTab === 'due_bills') {
          const dueBillsTab = () => this.router.navigate(['billing/ip_advance_payment/orderList'], { queryParams: { tab_0: 'due_bills' } });
          this.router.navigateByUrl('/search', { skipLocationChange: true }).then(dueBillsTab, dueBillsTab);
        } else {
          this.router.navigate(['billing/ip_advance_payment/orderList']);
        }
      }
      else {
        this.router.navigate(['order/my_orders_format/orderList']);
      }

    } else {
      this.router.navigate(['/login']);
    }
  }

  printReciept() {
    this.buttonAction(this.data.menuObj);
  }

  hide() {
    this.smartModelService.hide()
  }
}
